import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { CollectiblesPage } from '../collectibles/collectibles'; 

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-collshannon',
  templateUrl: 'collshannon.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class CollShannonPage {

  constructor(public functions: Functions, public rubedoSideMenu: MenuController, public translate: TranslateService, public navCtrl: NavController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);
  }  
  
  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }
  
  goToCollectibles(){
    this.navCtrl.setRoot(CollectiblesPage, {});
  }
}



// WEBPACK FOOTER //
// ./src/pages/collshannon/collshannon.ts